import React, { useState, useEffect } from 'react'
import { Promotionform } from './Promotionform'
import { Demotionform } from './Demotionform'
import { Terminationform } from './Terminationform'
import { Check, ChevronDown } from 'lucide-react'
import { Listbox } from '@headlessui/react'
import './Ticket.css'
import EmployeeTicketTable from '../TicketDetails/EmployeeTicket'
import EmployeeDetails from './EmployeeDetails'

const ticketOptions = [
  { name: 'Select Ticket', value: '' },
  { name: 'Promotion', value: 'promotion' },
  { name: 'Demotion', value: 'demotion' },
  { name: 'Termination', value: 'termination' },
]

export const Ticket = () => {
  // const [selected, setSelected] = useState(ticketOptions[1])
  const [showPromotionForm, setShowPromotionForm] = useState(true)
  const [showDemotionForm, setShowDemotionForm] = useState(false)
  const [showTerminationForm, setShowTerminationForm] = useState(false)
  const [activeForm, setActiveForm] = useState('promotion');

  // Only update the forms when selection changes
  // useEffect(() => {
  //   if (selected.name === 'Promotion') {
  //     setShowPromotionForm(true)
  //     setShowDemotionForm(false)
  //     setShowTerminationForm(false)
  //   } else if (selected.name === 'Demotion') {
      // setShowPromotionForm(false)
      // setShowDemotionForm(true)
      // setShowTerminationForm(false)
  //   } else if (selected.name === 'Termination') {
  //     setShowPromotionForm(false)
  //     setShowDemotionForm(false)
  //     setShowTerminationForm(true)
  //   } else {
      // setShowPromotionForm(false)
      // setShowDemotionForm(false)
      // setShowTerminationForm(false)
  //   }
  // }, [selected])

   const buttonStyles = (form) =>
  `p-2 rounded-md font-bold border-2 ${
    activeForm === form
      ? 'bg-white text-[#D95A00] border-[#D95A00]'
      : 'bg-[#EF7320] text-white border-transparent'
  }`;


  return (
    <div>
      <div className="p-3 m-3 bg-gray-100 rounded-lg shadow-lg">
        <div className="flex justify-around items-center">
          <label className="block text-md font-medium mb-1 text-gray-700 w-1/3 text-right">Ticket Type:</label>
          {/* <Listbox value={selected} onChange={setSelected} className="w-2/3">
            <div className="relative">
              <Listbox.Button className="w-full border border-gray-300 rounded px-4 py-2 text-left focus:outline-none focus:ring-2 focus:ring-[#EF7320] flex justify-between items-center">
                {selected.name}
                <ChevronDown className="w-4 h-4" />
              </Listbox.Button>
              <Listbox.Options className="absolute w-full mt-1 bg-white border border-gray-300 rounded shadow-md z-10">
                {ticketOptions.map((option, idx) => (
                  <Listbox.Option
                    key={idx}
                    value={option}
                    className={({ active, selected }) =>
                      `cursor-pointer px-4 py-2 text-sm ${
                        active ? 'bg-orange-100 text-orange-700' : 'text-gray-800'
                      } ${selected ? 'font-semibold' : ''}`
                    }
                  >
                    {({ selected }) => (
                      <div className="flex justify-between items-center">
                        {option.name}
                        {selected && <Check className="w-4 h-4 text-[#EF7320]" />}
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </div>
          </Listbox> */}

          < button className={buttonStyles('promotion')} onClick={()=>{setShowPromotionForm(true);  setShowDemotionForm(false);
    setShowTerminationForm(false); setActiveForm('promotion')} }>Promotion</button>
          < button className={buttonStyles('demotion')} onClick={()=>{    setShowPromotionForm(false)
      setShowDemotionForm(true)
      setShowTerminationForm(false);
      setActiveForm('demotion')}}>Demotion</button>
          < button className={buttonStyles('termination')}  onClick={()=>{setShowPromotionForm(false)
      setShowDemotionForm(false)
      setShowTerminationForm(true)
       setActiveForm('termination')}}>Termination</button>
           < button className={buttonStyles('others')}  onClick={()=>{setShowPromotionForm(false)
      setShowDemotionForm(false)
      setShowTerminationForm(true); setActiveForm('others')}}>Others</button>
        </div>
        
      </div>





      <div className="m-3">{showPromotionForm && <Promotionform />}</div>
      <div className="m-3">{showDemotionForm && <Demotionform />}</div>
      <div className="m-3">{showTerminationForm && <Terminationform />}</div>
      
    </div>
  )
}
